<template>
  <content-panel>
    <template v-slot:search>
      <search-box class="search-box">
        <el-form :inline="true" size="mini" label-width="100px" :model="searchForm" :rules="rules" ref="searchForm">
          <el-form-item label="SPU编码" prop="spuCode">
            <el-input v-model.trim="searchForm.spuCode" @keyup.enter.native="onSearch" />
          </el-form-item>
          <el-form-item label="SPU名称" prop="spuName">
            <el-input v-model.trim="searchForm.spuName" @keyup.enter.native="onSearch" />
          </el-form-item>
          <el-form-item label="SKU编码" prop="skuCode">
            <el-input v-model.trim="searchForm.skuCode" @keyup.enter.native="onSearch" />
          </el-form-item>
          <el-form-item label="SKU名称" prop="skuName">
            <el-input v-model.trim="searchForm.skuName" @keyup.enter.native="onSearch" />
          </el-form-item>
          <el-form-item label="产品编码" prop="productCode">
            <el-input v-model.trim="searchForm.productCode" @keyup.enter.native="onSearch" />
          </el-form-item>
          <el-form-item label="产品名称" prop="productName">
            <el-input v-model.trim="searchForm.productName" @keyup.enter.native="onSearch" />
          </el-form-item>
          <el-form-item label="大型号" prop="bigModel">
            <el-input v-model.trim="searchForm.bigModel" @keyup.enter.native="onSearch" />
          </el-form-item>
          <el-form-item label="类型" prop="processType">
            <el-select v-model="searchForm.processType" filterable clearable @change="onSearch">
              <el-option label="全部" value="" />
              <el-option v-for="item in ['修片', '渲染', '修片(模特)']" :label="item" :key="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="修片类型" prop="categoryType">
            <el-select v-model="searchForm.categoryType" filterable clearable @change="onSearch">
              <el-option label="全部" value="" />
              <el-option v-for="item in ['大片', '小片', '退底', '特写', '通道']" :label="item" :key="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="上传时间" prop="uploadDateQuery">
            <form-date-range
              :form="searchForm"
              startKey="uploadDateQueryStart"
              endKey="uploadDateQueryEnd"
              :usingTime="false"
              valueFormat="yyyyMMdd"
            ></form-date-range>
          </el-form-item>
        </el-form>
        <template v-slot:right>
          <el-button class="green-btn" size="mini" @click="onSearch">搜索</el-button>
          <el-button class="orange-btn" size="mini" @click="reset">重置</el-button>
        </template>
      </search-box>
    </template>

    <table-panel ref="tablePanel">
      <template v-slot:header-right>
        <el-button type="primary" size="mini" @click="exportExcel">导出</el-button>
      </template>
      <el-table
        stripe
        border
        ref="tableRef"
        :header-cell-style="{ backgroundColor: '#F4F8FB' }"
        highlight-current-row
        :data="tableData.list"
        :height="maxTableHeight"
        v-if="tableReload"
        v-loading="loading"
      >
        <el-table-column
          v-for="(item, index) in columnData"
          :key="item.columnName + index"
          :align="`${item.fieldType == 'string' ? 'left' : 'right'}`"
          show-overflow-tooltip
          :label="item.displayName"
          :fixed="item.freezeType"
          :prop="item.columnName"
          :min-width="item.displayWidth"
        >
          <template slot-scope="scope">
            {{ scope.row[item.columnName] | cellValFormat }}
          </template>
        </el-table-column>
      </el-table>
      <template v-slot:footer>
        <div style="text-align: right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.pageNum"
            :page-sizes="[30, 100, 500, 1000]"
            :page-size="tableData.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            background
            :total="tableData.total"
          ></el-pagination>
        </div>
      </template>
    </table-panel>
  </content-panel>
</template>

<script>
import pagePathMixin from '@/utils/page-path-mixin';
import tableMixin from '@/utils/tableMixin';
import axios from '@/utils/axiosInstance';
import moment from 'moment';

export default {
  name: 'photographySalaryAccounting',
  mixins: [tableMixin, pagePathMixin],
  components: {},
  data() {
    return {
      loading: false,
      tableData: {
        list: [],
        pageNum: 1,
        pageSize: 30,
        total: 0,
      },
      tableReload: true,
      searchFormData: [],
      rules: {},
      reportName: 'newProductPictureRetouchDetailInfo',
      columnData: [],
      loading: false,
      searchForm: {
        spuCode: '',
        spuName: '',
        skuCode: '',
        skuName: '',
        productCode: '',
        productName: '',
        bigModel: '',
        processType: '',
        categoryType: '',
        uploadDateQueryStart: moment().startOf('months').format('YYYYMMDD'),
        uploadDateQueryEnd: moment().endOf('months').format('YYYYMMDD'),
      },
      exportData: {},
      searchCollapse: false,
      queryCriteria: [],
      spuCategoryList: [],
      goodsLocationList: [],
      currencyForm: {
        pageSize: 999999,
        pageNum: 1,
        reportCode: '',
        param: {},
        queryMatch: [
          // {
          //   attributeName: '',
          //   val: {},
          //   op: ''
          // }
        ],
        orderList: [
          // {
          //   attributeName: '',
          //   type: ''
          // }
        ],
        orderType: '',
        hasCount: 'N',
        groupAttr: '',
      },
    };
  },
  computed: {},
  watch: {
    $route: {
      handler(val, olv) {
        if (
          olv.path == '/newProduct/filmRepairmanSalarySummary' &&
          (val.query.monthCode != this.searchForm.monthCode || val.query.workNo != this.searchForm.workNo) &&
          JSON.stringify(val.query) != '{}'
        ) {
          let { monthCode, workNo } = val.query || {};
          this.$set(this.searchForm, 'monthCode', monthCode);
          this.$set(this.searchForm, 'workNo', workNo);
          this.onSearch();
        }
      },
    },
  },
  methods: {
    columns() {
      this.loading = true;
      this.$q.goods.columns({ params: { reportName: this.reportName } }).then((res) => {
        this.columnData = res.data.sysColumns;
        this.onSearch();
      });
    },
    onSearch() {
      // 校验上传时间：可以都为空，但不能只填一个
      const start = this.searchForm.uploadDateQueryStart;
      const end = this.searchForm.uploadDateQueryEnd;
      if ((start && !end) || (!start && end)) {
        this.$message.warning('上传时间请选择完整的时间段');
        return;
      }
      this.$refs.tableRef.clearSelection();
      this.tableData.pageNum = 1;
      this.queryCriteria = [
        {
          attributeName: 'spuCode', //SPU编码
          val: [this.searchForm.spuCode ? this.searchForm.spuCode : ''],
          op: 'in',
        },
        {
          attributeName: 'spuName', //SPU名称
          val: this.searchForm.spuName ? this.searchForm.spuName : '',
          op: 'like',
        },
        {
          attributeName: 'skuCode', //SKU编码
          val: [this.searchForm.skuCode ? this.searchForm.skuCode : ''],
          op: 'in',
        },
        {
          attributeName: 'skuName', //SKU名称
          val: this.searchForm.skuName ? this.searchForm.skuName : '',
          op: 'like',
        },
        {
          attributeName: 'productCode', //产品编码
          val: [this.searchForm.productCode ? this.searchForm.productCode : ''],
          op: 'in',
        },
        {
          attributeName: 'productName', //产品名称
          val: this.searchForm.productName ? this.searchForm.productName : '',
          op: 'like',
        },
        {
          attributeName: 'bigModel', //大型号
          val: this.searchForm.bigModel ? this.searchForm.bigModel : '',
          op: 'like',
        },
        {
          attributeName: 'processType', //类型
          val: [this.searchForm.processType ? this.searchForm.processType : ''],
          op: 'in',
        },
        {
          attributeName: 'categoryType', //修片类型
          val: [this.searchForm.categoryType ? this.searchForm.categoryType : ''],
          op: 'in',
        },
        {
          attributeName: 'workNo', //工号
          val: this.searchForm.workNo ? this.searchForm.workNo : '',
          op: 'equal',
        },
        {
          attributeName: 'monthCode', //上传月份
          val: this.searchForm.monthCode ? this.searchForm.monthCode : '',
          op: 'equal',
        },
        {
          attributeName: 'uploadDateQuery', //上传时间
          val: start && end ? [start, end] : [],
          op: 'range',
        },
      ];
      this.init();
    },
    async init(type) {
      this.loading = true;
      let filter = this.queryCriteria.filter((item) => item.val.length && item.val[0]);
      let data = {
        pageSize: this.tableData.pageSize,
        pageNum: this.tableData.pageNum,
        reportCode: this.reportName,
        param: {},
        queryMatch: filter || [],
        orderList: [],
        orderByColumn: '',
        orderType: '',
        hasCount: 'Y',
      };
      if (type) {
        data.queryMatch = type.queryMatch;
        data.orderList = type.orderList;
      }
      this.searchFormData = data;
      axios
        .post(`/ec-pc-api/custom/reports/data/${this.reportName}`, data)
        .then((res) => {
          if (res.code == 200) {
            this.tableData = res.data;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 分页器 pagesize
    handleSizeChange(val) {
      this.tableData.pageSize = val;
      this.tableData.pageNum = 1;
      this.init(this.searchFormData);
    },
    // 分页器 pageNum
    handleCurrentChange(val) {
      this.tableData.pageNum = val;
      this.init(this.searchFormData);
    },

    reset() {
      this.$refs.searchForm.resetFields();
      this.tableData.pageNum = 1;
      this.onSearch();
    },

    // 导出
    exportExcel() {
      console.log(this.searchFormData);
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      });
      let params = {
        taskDTO: {
          appCode: 'ec-pc-new',
          paramMap: {
            ...this.searchFormData,
          },
          reportName: this.reportName,
        },
        columnDTOs: [],
      };
      params.columnDTOs = this.columnData
        .map((item) => {
          return {
            columnName: item.displayName,
            fieldName: item.columnName,
            fieldType: 'string',
            columnFormat: null,
          };
        })
        .filter((v) => v.columnName != '图片'); // 不导出图片列
      params.columnDTOs = params.columnDTOs.filter((v) => v.columnName !== '图片');
      this.$q.common.customExportExcel({ data: params }).then((res) => {
        if (res.success) {
          this.$message.success('提交下载任务成功，请稍后到导出列表查阅！');
          loading.close();
        } else {
          this.$message.error(res.message);
        }
      });
    },
  },
  filters: {
    cellValFormat(val) {
      if (val) {
        return val;
      } else {
        if (isNaN(val) || val == 0) {
          return val;
        } else {
          return '--';
        }
      }
    },
  },
  mounted() {
    let { monthCode, workNo } = this.$route.query || {};
    this.$set(this.searchForm, 'monthCode', monthCode || '');
    this.$set(this.searchForm, 'workNo', workNo || '');
    this.onSearch();
    this.columns();
  },
};
</script>

<style lang="stylus" scoped>
.search-box
  >>> .el-date-editor.el-input__inner, >>> .el-select, >>> .el-input
      width 240px !important
  >>> .date-range .single-date
    width 110px !important
</style>
